var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M22.707 1.293a1 1 0 0 1 .187 1.154l-10 20a1 1 0 0 1-1.888-.336l-.912-8.205-8.204-.912a1 1 0 0 1-.337-1.888l20-10a1 1 0 0 1 1.154.187z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }